import { render, staticRenderFns } from "./BlockLabel.vue?vue&type=template&id=46899b3f&scoped=true&"
import script from "./BlockLabel.vue?vue&type=script&lang=js&"
export * from "./BlockLabel.vue?vue&type=script&lang=js&"
import style0 from "./BlockLabel.vue?vue&type=style&index=0&id=46899b3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46899b3f",
  null
  
)

component.options.__file = "BlockLabel.vue"
export default component.exports